import Index from "../../pages/hjwq/anniversary/index";

const base = "anniversary";

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index,
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index,
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/hjwq/anniversary.js